/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var Assessment = { };

Assessment.answers = [ ];
Assessment.moduleAnswers = [ ];

Assessment.addAnswer = function ( obj ) {
	for ( var i = 0; i < Assessment.answers.length; i++ ) {
		if ( Assessment.answers[i].id === obj.id ) {
			Assessment.answers[i].value = obj.value;

			return;
		}
	}

	Assessment.answers.push( obj );
};

Assessment.addModuleAnswer = function ( module, answer ) {
	for ( var i = 0; i < Assessment.moduleAnswers.length; i++ ) {
		if ( Assessment.moduleAnswers[i].module === module ) {
			Assessment.moduleAnswers[i].values.push( answer );

			return;
		}
	}

	Assessment.moduleAnswers.push( { 'module': module, 'values': [ answer ] } );
};

( function ( $ ) {

	var form = $( '#AssessmentForm' );

	var loader = $( '#TakeAssessmentModal' ).find( '.loader' );

	$( document ).ready( function () {
		form.find( 'input[type="text"].answer' ).slider( {
			formatter: function ( value ) {
				return value;
			}
		} );

		form.find( '.next-btn' ).click( function ( e ) {
			e.preventDefault();

			var parent = $( this ).parents( '.assessment-step' );

			parent.fadeOut( 'fast' );

			if ( $( this ).is( '.question-btn' ) ) {
				var answer = $( this ).siblings( '.answer' );

				Assessment.addModuleAnswer( answer.data( 'module' ), answer.val() );
			}

			if ( $( this ).is( '.question-btn:last' ) ) {
				var nextParent = parent.next( '.assessment-step' );

				nextParent.find( '.assessment-summary' ).html( '' );

				loader.show();

				$.post( {
					url: assessmentCall.ajaxurl,
					data: { 'action': 'assessment', 'answers': JSON.stringify( Assessment.moduleAnswers ) },
					success: function ( response ) {
						Assessment.moduleAnswers = [ ];
						loader.hide();
						nextParent.find( '.assessment-summary' ).html( response );
					}
				} );
			}

			setTimeout( function () {
				if ( parent.next( '.assessment-step' ).is( ':last-child' ) ) {
					$( '.md-bg' ).parent().fadeOut( 'fast', function () {
						$( '.md-bg' ).show();

						parent.next( '.assessment-step' ).show();
					} ).fadeIn( 'fast' );
				} else {
					parent.next( '.assessment-step' ).fadeIn( 'fast' );
				}
			}, 300 );
		} );

		form.find( '.answer' ).change( function () {
			var answer = { id: $( this ).attr( 'name' ), module: $( this ).data( 'module' ), value: $( this ).val() };

			Assessment.addAnswer( answer );

			$( this ).siblings( '.disable-a' ).show();
			$( this ).siblings( '.question-btn' ).hide();

			if ( parseInt( $( this ).val() ) !== 0 ) {
				$( this ).siblings( '.disable-a' ).hide();
				$( this ).siblings( '.question-btn' ).show();
			}
		} );

		form.find( '.sign-up' ).click( function () {
			setTimeout( function () {
				$( '.md-bg' ).hide();
			}, 500 );
		} );
	} );

	$( '#SignupModal' ).on( 'shown.bs.modal', function () {
		$( 'body' ).addClass( 'modal-open' );
	} ).on( 'hidden.bs.modal', function () {
		$( 'body' ).removeClass( 'modal-open' ).attr( 'style', '' );
	} );

	$( '#LoginModal' ).on( 'shown.bs.modal', function () {
		$( 'body' ).addClass( 'modal-open' );
	} ).on( 'hidden.bs.modal', function () {
		$( 'body' ).removeClass( 'modal-open' ).attr( 'style', '' );
	} );

	$( '#PwdForgotModal' ).on( 'shown.bs.modal', function () {
		$( 'body' ).addClass( 'modal-open' );
	} ).on( 'hidden.bs.modal', function () {
		$( 'body' ).removeClass( 'modal-open' ).attr( 'style', '' );
	} );

	$( '#TakeAssessmentModal' ).on( 'show.bs.modal', function () {
		$( '#LoginModal' ).modal( 'hide' );
		$( 'body' ).attr( 'style', '' );
	} );

	$( '#SignupModal' ).on( 'show.bs.modal', function ( event ) {
		$( this ).find( '#AssessmentAnswers' ).text( JSON.stringify( Assessment.answers ) );

		$( '#TakeAssessmentModal' ).modal( 'hide' );

		// Reset assessment form
		form.find( '.assessment-step' ).each( function () {
			$( this ).hide();

			if ( $( this ).is( ':first-child' ) ) {
				$( this ).show();
			}

			if ( $( this ).hasClass( 'question' ) ) {
				$( this ).find( '.disable-a' ).show();
				$( this ).find( '.question-btn' ).hide();
			}
		} );

		$( '.assessment-summary' ).html( '' );

		form.find( 'input[type="text"].answer' ).slider( 'setValue', 0 );

		Assessment.moduleAnswers = [ ];
		Assessment.answers = [ ];
	} );

} )( jQuery );
